import React, { useState } from 'react'
import { PaymentQueueStatus } from '@getgreenline/homi-shared'
import { ParkedSaleButtonStatus } from './ParkedSaleStatusButtonLists'

interface Props {
  status: PaymentQueueStatus | undefined
  buttonStatus: ParkedSaleButtonStatus
  onClick?: VoidFunction
  disabled?: boolean
}

const ParkedSaleStatusButton = ({
  status,
  buttonStatus = ParkedSaleButtonStatus.DEFAULT,
  onClick,
  disabled,
}: Props) => {
  const [isHover, setHover] = useState(false)
  let statusText
  switch (status) {
    case PaymentQueueStatus.PENDING:
      statusText = { type: 'text-warning', text: 'Order placed' }
      break
    case PaymentQueueStatus.READY_FOR_PICKUP:
      statusText = { type: 'text-success', text: 'Ready for pickup' }
      break
    case PaymentQueueStatus.READY_FOR_DELIVERY:
      statusText = { type: 'text-success', text: 'Ready for delivery' }
      break
    case PaymentQueueStatus.OUT_FOR_DELIVERY:
      statusText = { type: 'text-info', text: 'Out for delivery' }
      break
    case PaymentQueueStatus.CANCELLED:
      statusText = { type: 'text-danger', text: 'Cancelled' }
      break
    case PaymentQueueStatus.COMPLETED:
      statusText = { type: 'text-primary', text: 'Completed' }
  }

  const buttonStyle = () => {
    switch (buttonStatus) {
      case ParkedSaleButtonStatus.DEFAULT:
        return 'default'
      case ParkedSaleButtonStatus.ACTIVE:
        return 'active'
      case ParkedSaleButtonStatus.DISABLED:
        return 'disabled'
    }
  }

  return (
    <div
      className={`parked-sale-status-button ${buttonStyle()}`}
      style={{
        cursor:
          disabled || buttonStatus === ParkedSaleButtonStatus.NOT_CLICKABLE
            ? 'not-allowed'
            : 'pointer',
      }}
      onPointerEnter={() => {
        setHover(true)
      }}
      onPointerLeave={() => {
        setHover(false)
      }}
      onClick={onClick}
    >
      <span className={`fa fa-circle ${statusText && statusText.type} mr-2`}></span>
      <p style={{ display: 'inline-block', marginBottom: 0 }}>{statusText && statusText.text}</p>
    </div>
  )
}

export default ParkedSaleStatusButton
